import script from "./MarketSupportSuccess.vue?vue&type=script&setup=true&lang=js"
export * from "./MarketSupportSuccess.vue?vue&type=script&setup=true&lang=js"

import "./MarketSupportSuccess.vue?vue&type=style&index=0&id=d88a9a2c&lang=scss&scoped=true"

import exportComponent from "/builds/p3839/client-suite/proxima_blue2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d88a9a2c"]])

export default __exports__